import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {ORDER_HEADERS} from './orderHeaders'

export const useSendRecaptchaTokenApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({order, recaptchaEnterprise}: Params.SendRecaptchaToken) => {
      const {data} = await ventrata.patch<Ventrata.Order>(
        `/orders/${order.id}`,
        {
          recaptchaEnterprise,
        },
        {
          headers: ORDER_HEADERS,
        }
      )

      return data
    },
    [ventrata]
  )
}
